import { jsxs, jsx } from "react/jsx-runtime";
const IconPropertyTownhouseSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    fill: "currentColor",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M16.447 5.634c.494.258.694.886.448 1.402-.247.517-.847.726-1.341.468L15 7.214v3.155l6.447 3.372c.494.259.694.887.448 1.404-.247.516-.847.725-1.341.467l-.554-.29v4.585h1c.552 0 1 .47 1 1.047 0 .578-.448 1.046-1 1.046H3c-.552 0-1-.468-1-1.046 0-.578.448-1.047 1-1.047h1V7.214l-.553.29c-.493.258-1.094.05-1.341-.467-.247-.517-.046-1.145.448-1.403L9.5 2l6.947 3.634ZM6 6.168v13.74h7V6.167L9.5 4.336 6 6.168Zm9 13.74h3v-5.632l-3-1.569v7.2Z" })
    ]
  }
);
export {
  IconPropertyTownhouseSvg
};
